var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DkMitId } from "./DkMitId";
import { FiTupas } from "./FiTupas";
import { DkNemId } from "./DkNemId";
import { FiMobiilivarmenne } from "./FiMobiilivarmenne";
import './EIdProviderListItem.scss';
var eIdProviderMeta = {
    fi_tupas: {
        name: "Bank ID",
        logo: FiTupas,
    },
    fi_mobiilivarmenne: {
        name: "Mobiilivarmenne",
        logo: FiMobiilivarmenne,
    },
    dk_nemid_js: {
        name: "NemID",
        logo: DkNemId,
    },
    "dk_nemid-opensign": {
        name: "NemID with code card",
        logo: DkNemId,
    },
    mitid: {
        name: "MitID",
        logo: DkMitId,
    },
};
export var EIdProviderListItem = function (_a) {
    var eIdProvider = _a.eIdProvider, onClick = _a.onClick;
    var Logo = eIdProviderMeta[eIdProvider].logo;
    return (_jsxs("button", __assign({ type: "button", className: "card-list-item e-id-provider-list-item", onClick: function () { return onClick(eIdProvider); } }, { children: [_jsx("span", __assign({ className: "icon-wrapper" }, { children: _jsx(Logo, {}) })), eIdProviderMeta[eIdProvider].name] })));
};
